import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { initMonitoring, stopMonitoring } from '@/lib/monitoring';

/**
 * Bindet den Sentry-Lebenszyklus an den Auth-Zustand:
 *  - eingeloggt  → initMonitoring (lädt das SDK erst hier, dynamisch)
 *  - ausgeloggt  → stopMonitoring (schließt den Client)
 *
 * Dadurch wird Sentry nie in den öffentlichen Portal-Bundles geladen (das SDK
 * kommt ausschließlich über den dynamischen Import in initMonitoring). Rendert nichts.
 */
export default function MonitoringController(): null {
    const { user, isAuthenticated } = useAuth();

    useEffect(() => {
        if (isAuthenticated && user) {
            void initMonitoring({ id: user.id, role: user.role });
        } else {
            void stopMonitoring();
        }
    }, [isAuthenticated, user]);

    return null;
}
